import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  getLatestAccountActivitySignalsOperation,
  pingRecipesServiceOperation,
} from '../../operations/user_profile_operations';
import { userIsCreator } from '../../services/users';
import {
  activitySignalsAvailable,
  activitySignalsOwnPublicIpAvailable,
  serverStatusUpdated,
  ServerStatusValue,
} from '../../features/server_status/server_status_slice';
import { useGetUserProfileQuery } from '../../app/smorgAppSyncGraphQLApiCustomHooks';
import { useGetSpaceQuery } from '../../app/smorgAppSyncGraphQLApi';

const ServerStatusControl = () => {
  const dispatch = useDispatch();

  const { data: userProfile } = useGetUserProfileQuery();

  const isSmorgStudio = userIsCreator(userProfile);

  const { data: healthProSpace } = useGetSpaceQuery(undefined, {
    skip: !userProfile || !isSmorgStudio,
  });

  const spaceID = healthProSpace?.id;

  const connectControl = useCallback(async () => {
    const awaitTimer = setTimeout(
      () => dispatch(serverStatusUpdated(ServerStatusValue.Checking)),
      1000,
    );
    console.log(JSON.stringify({ isSmorgStudio, spaceID }));
    try {
      if (isSmorgStudio) {
        if (spaceID) {
          const [signals, pingResponse] = await Promise.all([
            getLatestAccountActivitySignalsOperation(spaceID),
            pingRecipesServiceOperation(),
          ]);
          if (pingResponse.publicIp) {
            dispatch(
              activitySignalsOwnPublicIpAvailable(pingResponse.publicIp),
            );
          }
          dispatch(activitySignalsAvailable(signals));
          console.log(pingResponse);
        }
        return ServerStatusValue.Ready;
      }
      const pingResponse = await pingRecipesServiceOperation();
      console.log(pingResponse);
      return ServerStatusValue.Ready;
    } catch (error) {
      return ServerStatusValue.NotReady;
    } finally {
      clearTimeout(awaitTimer);
    }
  }, [dispatch, isSmorgStudio, spaceID]);

  const cancelServerStatusControl = () => {
    if (window._gServerStatusInterval) {
      console.log('Clearing interval for health check');
      clearInterval(window._gServerStatusInterval);
      window._gServerStatusInterval = null;
    }
  };

  const serverStatusControlLoop = useCallback(async () => {
    if (!window._gServerStatusInterval) {
      const initialServerStatus = await connectControl();
      dispatch(serverStatusUpdated(initialServerStatus));

      console.log('Setting interval for health check');
      window._gServerStatusInterval = setInterval(async () => {
        const newServerStatus = await connectControl();
        dispatch(serverStatusUpdated(newServerStatus));
      }, 60000);
    } else {
      console.log('Not setting interval for health check');
    }
  }, [connectControl, dispatch]);

  useEffect(() => {
    serverStatusControlLoop();
    return () => {
      cancelServerStatusControl();
    };
  }, [serverStatusControlLoop]);

  return null;
};

export default ServerStatusControl;
